export default {
    getOldIconFromFileId: function(fileName) {
        ////console.log(fileName)
        //return require('./assets/oldicons/Support-skill-1.png')
        return require('../../assets/oldicons/' + fileName + '.png');
    }
}
